import { render, staticRenderFns } from "./news.vue?vue&type=template&id=7165dc79&"
import script from "./news.js?vue&type=script&lang=js&"
export * from "./news.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports